module.exports = __webpack_public_path__ + "img/jerry.1a51879f.jpg";